// frontend/src/api.js

import apiClient from './apiClient';

// Funktion f�r att hantera inloggning
export const login = async (username, password) => {
  try {
    const response = await apiClient.post('/auth/login', { username, password });
    return response.data; // { access_token: "..." }
  } catch (error) {
    console.error('Login API Error:', error);
    throw error;
  }
};

// Funktion f�r att h�mta mallar
export const getTemplates = async () => {
  try {
    const response = await apiClient.get('/api/journalmallar');
    return response.data;
  } catch (error) {
    throw error.response?.data?.msg || 'H�mta mallar misslyckades';
  }
};

// L�gg till andra API-funktioner vid behov
